import {SetStateAction} from "react";

export default function activeUserCountHandler(setActiveUserCount: SetStateAction<any>) {
    return (event: Event) => {
        const {detail: count} = event as CustomEvent;

        setActiveUserCount(count);
    };
}